import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    updatedByInfo: {
      paddingTop: 8,
      '& .MuiTypography-root': {
        fontSize: 12,
      },
    },
  });
